var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChileFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10V0.526338C0 0.235683 0.231621 0 0.517265 0H30V10H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03447 9.99997V9.47363H0V9.99997V10.5263V20H30V9.99997H1.03447Z",
    fill: "#FF4B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82762 10H0L0 0H9.82762V10Z",
    fill: "#41479B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11211 2.75545L5.60524 4.25994L7.16383 4.27222C7.36562 4.27377 7.4493 4.53587 7.28693 4.65779L6.03315 5.59987L6.50324 7.11199C6.56406 7.30779 6.34504 7.46966 6.18086 7.3503L4.9129 6.42813L3.64487 7.35036C3.48069 7.46978 3.26167 7.30779 3.32249 7.11205L3.79259 5.59993L2.5388 4.65785C2.37644 4.53587 2.46011 4.27383 2.6619 4.27228L4.22049 4.26L4.71362 2.75551C4.77749 2.56067 5.04831 2.56067 5.11211 2.75545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChileFlag);
export default __webpack_public_path__ + "static/media/chileFlag.4730bd8a8a6108c556edd48d3002ee15.svg";
export { ForwardRef as ReactComponent };